import type { AIModelChoices, Annotation } from 'api';

import { EMPTY_HIDDEN_CATEGORIES } from '../../constants';
import { SegmentationOverlay } from '../SegmentationOverlay/SegmentationOverlay';

interface AnnotatedMediaItemProps {
  image: string;
  annotations: Annotation[];
  showLegend?: boolean;
  showAerosols?: boolean;
  hiddenCategories?: readonly string[];
  model: AIModelChoices;
  evidenceId: number;
  showFeedback?: boolean;
}

export const AnnotatedMediaItem = ({
  image,
  annotations,
  showLegend = true,
  showAerosols = true,
  hiddenCategories = EMPTY_HIDDEN_CATEGORIES,
  model,
  evidenceId,
  showFeedback = false,
}: AnnotatedMediaItemProps) => {
  return (
    <SegmentationOverlay
      imageSrc={image}
      annotations={annotations}
      hiddenCategories={hiddenCategories}
      model={model}
      showFeedback={showFeedback}
      showLegend={showLegend}
      showAerosols={showAerosols}
      evidenceId={evidenceId}
    />
  );
};
